import React from "react";
import clsx from "clsx";
import DashboardChart from "./DashboardChart";
import { DASHBOARD_SLOTS } from "./constants";

const DashboardSlot = ({ slotPosition, slotId, editMode, editModeSlot, containerClass }) => {
  return (
    <div
      className={clsx(
        `slot ${slotId} min-h-[35vh] w-full`,
        editMode && "flex items-center justify-center",
        containerClass
      )}
      data-swapy-slot={slotPosition}
    >
      <DashboardChart
        slotId={slotId}
        editMode={editMode}
        editModeSlot={editModeSlot}
      />
    </div>
  );
};

export default DashboardSlot;
